var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwesomeEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "awesome-edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.326,
    height: 26.32,
    viewBox: "0 0 26.326 26.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-edit",
    "data-name": "Icon awesome-edit",
    d: "M25.476,5.266l5.708,5.708a.619.619,0,0,1,0,.873l-13.82,13.82-5.872.652a1.231,1.231,0,0,1-1.361-1.361l.652-5.872L24.6,5.266A.619.619,0,0,1,25.476,5.266ZM35.728,3.816,32.64.728a2.475,2.475,0,0,0-3.493,0l-2.24,2.24a.619.619,0,0,0,0,.873L32.614,9.55a.619.619,0,0,0,.873,0l2.24-2.24a2.475,2.475,0,0,0,0-3.493Z",
    transform: "translate(-10.123 -0.007)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwesomeEdit);
export default __webpack_public_path__ + "static/media/awesome-edit.910beac115339dc7cbfdf1018b1713ab.svg";
export { ForwardRef as ReactComponent };